import React, { Component } from "react";
import PropTypes from "prop-types";
import LinkifyBase from "./social/LinkifyBase";

/**
 *
 * Component that truncates a large text
 * and adds a link to 'Show more' / ' Show less'
 *
 * Props:
 *      text{string} - required: the text to truncate
 *      truncate{int} - required: the number of characters to show by default
 */

export default class TextExpander extends Component {
  constructor() {
    super();
    this.state = { expanded: false };
  }

  // Used to avoid cases where the text is truncated in %%PUB...
  getTruncatedText(text, trucateCharsNumber) {
    const incompletedPubmedRegex = new RegExp(/%%PUB?M?E?D?:?\d*%?%?/g);
    const completedPubmedRegex = new RegExp(/%%PUBMED:(\d+)%%/g);
    const initialTruncText = text.slice(0, trucateCharsNumber);
    const incompletedPubmedMatches = initialTruncText.match(
      incompletedPubmedRegex
    );

    if (
      !Array.isArray(incompletedPubmedMatches) ||
      !incompletedPubmedMatches ||
      incompletedPubmedMatches?.length === 0
    ) {
      return initialTruncText;
    }

    const completedPubmedMatches = incompletedPubmedMatches.filter((i) =>
      i.match(completedPubmedRegex)
    );
    if (incompletedPubmedMatches.length === completedPubmedMatches.length) {
      return initialTruncText;
    }
    const updatedTruncateCharsNumber = trucateCharsNumber + 1;
    return this.getTruncatedText(text, updatedTruncateCharsNumber);
  }

  toggleExpanded() {
    const { expanded } = this.state;
    this.setState({ expanded: !expanded });
  }

  render() {
    const { truncate, text } = this.props;
    const txt = String(text || "");
    const { expanded } = this.state;
    const limit = Math.floor(Number(truncate));
    const showExpander = limit < txt?.length + 5;
    const isSliced = txt.length > limit && !expanded;

    const visibleText = isSliced ? `${txt.slice(0, limit)}...` : txt;

    return (
      <>
        <LinkifyBase txt={visibleText} />

        {showExpander && (
          <a
            className="tw-cursor-pointer tw-ml-2"
            onClick={this.toggleExpanded.bind(this)}
          >
            <small>
              {expanded ? (
                <span className="tw-whitespace-nowrap">
                  Show less <i className="varsome-icons icon-chevron-up" />
                </span>
              ) : (
                <span className="tw-whitespace-nowrap">
                  {"Show more "}
                  <i className="varsome-icons icon-chevron-down" />
                </span>
              )}
            </small>
          </a>
        )}
      </>
    );
  }
}

TextExpander.propTypes = {
  text: PropTypes.string,
  truncate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

TextExpander.defaultProps = {
  text: null,
  truncate: null,
};
